import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Markers } from '../markers';
import { Latng } from '../latng';
import MapMouseEvent = google.maps.MapMouseEvent;

@Component({
  selector: 'app-address-picker',
  templateUrl: './address-picker.component.html',
  styleUrls: ['./address-picker.component.scss']
})
export class AddressPickerComponent implements OnInit, OnChanges {

  @Input()
  latitude: number;

  @Input()
  longitude: number;

  @Input()
  radius: number;

  @Output()
  onValidation = new EventEmitter<Latng>();

  markerUrl = Markers.SERVICE_CENTER.grey;

  zoom = 14;

  dirtyPosition = false;

  mapLatitude: number;

  mapLongitude: number;

  markerLatitude: number;

  markerLongitude: number;

  constructor() {
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.latitude && changes.latitude.currentValue) {
      this.mapLatitude    = changes.latitude.currentValue;
      this.markerLatitude = changes.latitude.currentValue;
    }

    if (changes.longitude && changes.longitude.currentValue) {
      this.mapLongitude    = changes.longitude.currentValue;
      this.markerLongitude = changes.longitude.currentValue;
    }
  }

  markerMoved(event: MapMouseEvent) {
    this.dirtyPosition   = true;
    this.mapLatitude     = event.latLng.lat();
    this.mapLongitude    = event.latLng.lng();
    this.markerLatitude  = event.latLng.lat();
    this.markerLongitude = event.latLng.lng();
  }

  cancel() {
    this.dirtyPosition   = false;
    this.mapLatitude     = this.latitude;
    this.mapLongitude    = this.longitude;
    this.markerLatitude  = this.latitude;
    this.markerLongitude = this.longitude;
  }

  save() {
    this.dirtyPosition = false;
    this.latitude      = this.markerLatitude;
    this.longitude     = this.markerLongitude;

    this.onValidation.emit({ latitude: this.markerLatitude, longitude: this.markerLongitude });
  }
}
